import Vue from "vue";
import $http from "../api/api.js";
// import $public from '../../util/public.js'
import createPersistedState from "vuex-persistedstate";
import mendian from "./children/mendian.js";
import yiliaoxin from "./children/yiliaoxin.js";
import jiyang from "./children/jiyang.js";
import ximei from "./children/ximei.js";
import yuyue from "./children/yuyue.js";
import caiwu from "./children/caiwu.js";
import saleGiftCard from "./children/saleGiftCard.js";
import xizaoka from "./children/xizaoka.js";
import xizaokaUpdate from "./children/xizaokaUpdate.js";
import guahao from "./children/guahao.js";
import jifen from "./children/jifen.js";
import activity from "./children/activity.js";
import living from "./children/living.js";
import livingUpdate from "./children/livingUpdate.js";
import recharge from "./children/recharge.js";
import yajin from "./children/yajin.js";
import giftCard from "./children/giftCard.js";
import huiyuanquanyi from "./children/huiyuanquanyi.js";
import ymqc from "./children/ymqc.js";
import jiedai from "./children/jiedai.js";
import ing from "./children/ing.js";
import signalr from "./children/signalr.js";
import jiyangguanli from "./children/jiyangguanli.js";
import memberCenter from "./children/memberCenter.js";
import Vuex from "vuex";
import $public from "../util/public.js";


Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    mendian,
    yiliaoxin,
    jiyang,
    caiwu,
    ximei,
    yuyue,
    signalr,
    xizaoka,
    saleGiftCard,
    xizaokaUpdate,
    guahao,
    jifen,
    activity,
    living,
    livingUpdate,
    recharge,
    yajin,
    giftCard,
    huiyuanquanyi,
    ymqc,
    jiedai,
    ing,
    jiyangguanli,
    memberCenter,
  },
  state: {
    version: process.env.NODE_ENV === "development" ? "5.0.0.000" : "3.3.0.200",
    // 区域列表
    areaList: [],
    // mySystemList:[],
    myShopList: [],

    msg_online: {
      reservationList: [],
      orderList: [],
    },
    userInfo: "",
    shopId: "",
    printUrl: "",
    curNavIndex_mendian: {}, // {title:item.title,path:item.path}
    curNavIndex_ximei: {},
    curNavIndex_yiliaoxin: {},
    curNavIndex_jiyang: {},
    curNavIndex_pandian: {},
    curNavIndex_yuyue: {},
    curNavIndex_guoqi: {},
    curNavIndex_ximeiyuyue: {},
    curNavIndex_dingdan: {},
    curNavIndex_rechargeOrder: {},
    curNavIndex_returnOrder: {},
    curNavIndex_arrearsOrder: {},
    curNavIndex_onlineOrder: {},
    curNavIndex_onlineReturn: {},
    curNavIndex_version: {},
    curNavIndex_jiaocheng: {},
    curNavIndex_yiliao: {},
    curNavIndex_wsSystem: {},
    curNavIndex_caiwu: {},
    // 旧仓储
    curNavIndex_caigouMendian: {},
    curNavIndex_caigou: {},
    curNavIndex_wuliao: {},
    curNavIndex_yujing: {},
    curNavIndex_chuku: {},
    curNavIndex_ruku: {},
    curNavIndex_kucun: {},
    // 新仓储
    curNavIndex_caigouMendianNew: {},
    curNavIndex_caigouNew: {},
    curNavIndex_yujingNew: {},
    curNavIndex_chukuNew: {},
    curNavIndex_rukuNew: {},
    curNavIndex_kucunNew: {},

    curNavIndex_huotiZongcang: {},
    curNavIndex_housePeizhi: {},
    curNavIndex_huotiStock: {},
    curNavIndex_huotiHouse: {},
    curNavIndex_huotiMendian: {},
    curNavIndex_huotiPeizhi: {},
    curNavIndex_huotiCharge: {},
    curNavIndex_huoti: {},
    curNavIndex_huodong: {},
    curNavIndex_brand: {},
    curNavIndex_gongyingshang: {},
    curNavIndex_signature: {},
    curNavIndex_template: {},

    curNavIndex_tiaoma: {},
    curNavIndex_chanpin: {},
    curNavIndex_medical: {},
    curNavIndex_group: {},
    curNavIndex_lifeservice: {},
    curNavIndex_medicalservice: {},
    curNavIndex_consumables: {},
    curNavIndex_fictitious: {},
    curNavIndex_livingbody: {},
    curNavIndex_controlStaff: {},
    curNavIndex_controlRole: {},
    curNavIndex_controlRight: {},
    curNavIndex_dingding: {},
    curNavIndex_goods: {},
    curNavIndex_huiyuan: {},
    curNavIndex_shuju: {},
    curNavIndex_moneypk: {},
    curNavIndex_Newmoneypk: {},
    curNavIndex_staffshuju: {},
    curNavIndex_huotishuju: {},
    curNavIndex_goodshuju: {},
    curNavIndex_quanxian: {},
    curNavIndex_yingxiao: {},

    curNavIndex_vipPower: {},
    curNavIndex_mall: {},
    curNavIndex_xiaoxi: {},
    curNavIndex_file: {},
    curNavIndex_fileStatistics: {},
    curNavIndex_refund: {},
    curNavIndex_shezhi: {},
    curNavIndex_program: {},
    curNavIndex_petshop: {},
    curNavIndex_petlooking: {},
    curNavIndex_petgift: {},
    curNavIndex_breedplan: {},
    curNavIndex_join: {},
    curNavIndex_special: {},
    curNavIndex_goodsShop: {},

    curNavIndex_oa: {},
    ip: "",
    yuyueUserId: "",
    yuyuePetId: "",
    payType_options: [
      { value: -1, label: "全部" },
      { value: 0, label: "现金" },
      // {value:1,label:'线上支付宝'},
      // {value:2,label:'线上微信'},
      // {value:3,label:'线下支付宝'},
      // {value:4,label:'线下微信'},
      { value: 5, label: "pos" },
      // {value:6,label:'找零'},
      { value: 7, label: "余额" },
      // {value:8,label:'增额'},
      // {value:9,label:'积分'},
      // {value:10,label:'押金'},
      // {value:11,label:'其他'},
      { value: 11, label: "电商平台" },
      { value: 12, label: "优惠" },
      { value: 13, label: "京东聚合" },
      { value: 17, label: "拉卡拉" },
    ],

    msg_unread_num_obj: {
      globalMsgSum: {
        commonMsg: 0,
        policyMsg: 0,
        shopMsg: 0,
      },
      myMsgSum: {
        commonMsg: 0,
        policyMsg: 0,
        shopMsg: 0,
      },
    },
  },
  getters: {
    curShopInfo(state) {
      if (state.shopId) {
        return state.userInfo.shopInfos.filter((item) => {
          return item.shop_id == state.shopId;
        })[0];
      } else {
        return {};
      }
    },
    shopList(state) {
      // label value shop_name shop_id original_shop_name
      let arr = [];
      for (let i = 0; i < state.userInfo.shopInfos.length; i++) {
        let item = state.userInfo.shopInfos[i];
        item.label = $public.getShopNameById(item.shop_id);
        item.value = item.shop_id;
        item.original_shop_name = item.shop_name;
        item.shop_name = $public.getShopNameById(item.shop_id);
        arr.push(item);
      }
      return arr;
    },
  },
  mutations: {
    // set_mySystemList(state, obj) {
    // 	state.mySystemList = obj;
    // },
    // 区域列表
    set_areaList(state, obj) {
      state.areaList = obj;
    },
    set_myShopList(state, obj) {
      state.myShopList = obj;
    },
    set_yuyueUserId(state, payload) {
      state.yuyueUserId = payload;
    },
    set_yuyuePetId(state, payload) {
      state.yuyuePetId = payload;
    },

    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setShopId(state, payload) {
      state.shopId = payload;
    },
    setIp(state, payload) {
      state.ip = payload;
    },
    set_printUrl(state, str) {
      state.printUrl = str;
    },
    setCurNavIndex_mendian(state, num) {
      state.curNavIndex_mendian = num;
    },
    setCurNavIndex_yiliaoxin(state, num) {
      state.curNavIndex_yiliaoxin = num;
    },
    setCurNavIndex_ximei(state, num) {
      state.curNavIndex_ximei = num;
    },
    setCurNavIndex_yuyue(state, num) {
      state.curNavIndex_yuyue = num;
    },
    setCurNavIndex_jiyang(state, num) {
      state.curNavIndex_jiyang = num;
    },
    setCurNavIndex_pandian(state, num) {
      state.curNavIndex_pandian = num;
    },

    setCurNavIndex_dingdan(state, num) {
      state.curNavIndex_dingdan = num;
    },
    setCurNavIndex_rechargeOrder(state, num) {
      state.curNavIndex_rechargeOrder = num;
    },
    setCurNavIndex_returnOrder(state, num) {
      state.curNavIndex_returnOrder = num;
    },
    setCurNavIndex_arrearsOrder(state, num) {
      state.curNavIndex_arrearsOrder = num;
    },
    setCurNavIndex_onlineOrder(state, num) {
      state.curNavIndex_onlineOrder = num;
    },
    setCurNavIndex_onlineReturn(state, num) {
      state.curNavIndex_onlineReturn = num;
    },
    setCurNavIndex_housePeizhi(state, num) {
      state.curNavIndex_housePeizhi = num;
    },
    setCurNavIndex_ximeiyuyue(state, num) {
      state.curNavIndex_ximeiyuyue = num;
    },


    setCurNavIndex_jiaocheng(state, num) {
      state.curNavIndex_jiaocheng = num;
    },
    setCurNavIndex_controlStaff(state, num) {
      state.curNavIndex_controlStaff = num;
    },
    setCurNavIndex_controlRole(state, num) {
      state.curNavIndex_controlRole = num;
    },

    setCurNavIndex_controlRight(state, num) {
      state.curNavIndex_controlRight = num;
    },
  
    setCurNavIndex_guoqi(state, num) {
      state.curNavIndex_guoqi = num;
    },
    setCurNavIndex_yiliao(state, num) {
      state.curNavIndex_yiliao = num;
    },

    setCurNavIndex_wsSystem(state, num) {
      state.curNavIndex_wsSystem = num;
    },

    setCurNavIndex_caiwu(state, num) {
      state.curNavIndex_caiwu = num;
    },
  
   
    setCurNavIndex_huotiZongcang(state, num) {
      state.curNavIndex_huotiZongcang = num;
    }, setCurNavIndex_huotiStock(state, num) {
      state.curNavIndex_huotiStock = num;
    },

    setCurNavIndex_huotiCharge(state, num) {
      state.curNavIndex_huotiCharge = num;
    },
    setCurNavIndex_huotiMendian(state, num) {
      state.curNavIndex_huotiMendian = num;
    },
    setCurNavIndex_huotiHouse(state, num) {
      state.curNavIndex_huotiHouse = num;
    },
    setCurNavIndex_huotiPeizhi(state, num) {
      state.curNavIndex_huotiPeizhi = num;
    },

    setCurNavIndex_huoti(state, num) {
      state.curNavIndex_huoti = num;
    },
    setCurNavIndex_brand(state, num) {
      state.curNavIndex_brand = num;
    },
    setCurNavIndex_gongyingshang(state, num) {
      state.curNavIndex_gongyingshang = num;
    },
    setCurNavIndex_signature(state, num) {
      state.curNavIndex_signature = num;
    },
    setCurNavIndex_template(state, num) {
      state.curNavIndex_template = num;
    },
  
    setCurNavIndex_tiaoma(state, num) {
      state.curNavIndex_tiaoma = num;
    },

    setCurNavIndex_huodong(state, num) {
      state.curNavIndex_huodong = num;
    },
    // 旧仓储
    setCurNavIndex_caigouMendian(state, num) {
      state.curNavIndex_caigouMendian = num;
    },
    setCurNavIndex_caigou(state, num) {
      state.curNavIndex_caigou = num;
    },
    setCurNavIndex_wuliao(state, num) {
      state.curNavIndex_wuliao = num;
    },
    setCurNavIndex_kucun(state, num) {
      state.curNavIndex_kucun = num;
    },
    setCurNavIndex_chuku(state, num) {
      state.curNavIndex_chuku = num;
    },
    setCurNavIndex_ruku(state, num) {
      state.curNavIndex_ruku = num;
    },
    setCurNavIndex_yujing(state, num) {
      state.curNavIndex_yujing = num;
    },
    // 新仓储
    setCurNavIndex_caigouMendianNew(state, num) {
      state.curNavIndex_caigouMendianNew = num;
    },
    setCurNavIndex_caigouNew(state, num) {
      state.curNavIndex_caigouNew = num;
    },
    setCurNavIndex_kucunNew(state, num) {
      state.curNavIndex_kucunNew = num;
    },
    setCurNavIndex_chukuNew(state, num) {
      state.curNavIndex_chukuNew = num;
    },
    setCurNavIndex_rukuNew(state, num) {
      state.curNavIndex_rukuNew = num;
    },
    setCurNavIndex_yujingNew(state, num) {
      state.curNavIndex_yujingNew = num;
    },


    setCurNavIndex_huiyuan(state, num) {
      state.curNavIndex_huiyuan = num;
    },
    setCurNavIndex_dingding(state, num) {
      state.curNavIndex_dingding = num;
    },
    setCurNavIndex_shuju(state, num) {
      state.curNavIndex_shuju = num;
    },
    setCurNavIndex_moneypk(state, num) {
      state.curNavIndex_moneypk = num;
    },
    setCurNavIndex_Newmoneypk(state, num) {
      state.curNavIndex_Newmoneypk = num;
    },
    setCurNavIndex_staffshuju(state, num) {
      state.curNavIndex_staffshuju = num;
    },
    setCurNavIndex_huotishuju(state, num) {
      state.curNavIndex_huotishuju = num;
    },
    setCurNavIndex_goodshuju(state, num) {
      state.curNavIndex_goodshuju = num;
    },

    setCurNavIndex_quanxian(state, num) {
      state.curNavIndex_quanxian = num;
    },
    setCurNavIndex_version(state, num) {
      state.curNavIndex_version = num;
    },
    setCurNavIndex_yingxiao(state, num) {
      state.curNavIndex_yingxiao = num;
    },
    setCurNavIndex_chanpin(state, num) {
      state.curNavIndex_chanpin = num;
    },
    setCurNavIndex_lifeservice(state, num) {
      state.curNavIndex_lifeservice = num;
    },
    setCurNavIndex_group(state, num) {
      state.curNavIndex_group = num;
    },
    setCurNavIndex_medicalservice(state, num) {
      state.curNavIndex_medicalservice = num;
    },
    setCurNavIndex_livingbody(state, num) {
      state.curNavIndex_livingbody = num;
    },
    setCurNavIndex_fictitious(state, num) {
      state.curNavIndex_fictitious = num;
    },
    setCurNavIndex_consumables(state, num) {
      state.curNavIndex_consumables = num;
    },


    setCurNavIndex_medical(state, num) {
      state.curNavIndex_medical = num;
    },
    setCurNavIndex_vipPower(state, num) {
      state.curNavIndex_vipPower = num;
    },
    setCurNavIndex_mall(state, num) {
      state.curNavIndex_mall = num;
    },
    setCurNavIndex_xiaoxi(state, num) {
      state.curNavIndex_xiaoxi = num;
    },
    setCurNavIndex_file(state, num) {
      state.curNavIndex_file = num;
    },
    setCurNavIndex_fileStatistics(state, num) {
      state.curNavIndex_fileStatistics = num;
    },

    setCurNavIndex_refund(state, num) {
      state.curNavIndex_refund = num;
    },
    setCurNavIndex_shezhi(state, num) {
      state.curNavIndex_shezhi = num;
    },
    setCurNavIndex_program(state, num) {
      state.curNavIndex_program = num;
    },
    setCurNavIndex_petshop(state, num) {
      state.curNavIndex_petshop = num;
    },
    setCurNavIndex_petlooking(state, num) {
      state.curNavIndex_petlooking = num;
    },
    setCurNavIndex_petgift(state, num) {
      state.curNavIndex_petgift = num;
    },
    setCurNavIndex_breedplan(state, num) {
      state.curNavIndex_breedplan = num;
    },
    setCurNavIndex_join(state, num) {
      state.curNavIndex_join = num;
    },
    setCurNavIndex_special(state, num) {
      state.curNavIndex_special = num;
    },
    setCurNavIndex_goodsShop(state, num) {
      state.curNavIndex_goodsShop = num;
    },
    setCurNavIndex_goods(state, num) {
      state.curNavIndex_goods = num;
    },

    setCurNavIndex_oa(state, num) {
      state.curNavIndex_oa = num;
    },
  },
  actions: {
    // getMsg_unread_num_obj({ commit }) {
    //   let d = new Date();
    //   let params = {};
    //   $http
    //     .post(
    //       process.env.VUE_APP_Url_8004 +
    //       "/api/message/noReads/Count?a=" +
    //       d.getTime(),
    //       params
    //     )
    //     .then((res) => {
    //       if (res.code == 0) {
    //         commit("setMsg_unread_num_obj", res.data);
    //       }
    //     });
    // },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return {
          areaList: val.areaList,
          yuyueUserId: val.yuyueUserId,
          yuyuePetId: val.yuyuePetId,
          msg_online: val.msg_online,
          userInfo: val.userInfo,
          myShopList: val.myShopList,
          shopId: val.shopId,
          curNavIndex_mendian: val.curNavIndex_mendian,
          curNavIndex_dingdan: val.curNavIndex_dingdan,
          curNavIndex_onlineReturn: val.curNavIndex_onlineReturn,
          curNavIndex_onlineOrder: val.curNavIndex_onlineOrder,
          curNavIndex_arrearsOrder: val.curNavIndex_arrearsOrder,
          curNavIndex_returnOrder: val.curNavIndex_returnOrder,
          curNavIndex_rechargeOrder: val.curNavIndex_rechargeOrder,
          curNavIndex_guoqi: val.curNavIndex_guoqi,
          curNavIndex_yiliao: val.curNavIndex_yiliao,
          curNavIndex_yiliaoxin: val.curNavIndex_yiliaoxin,
          curNavIndex_jiyang: val.curNavIndex_jiyang,
          curNavIndex_pandian: val.curNavIndex_pandian,
          curNavIndex_caiwu: val.curNavIndex_caiwu,
          curNavIndex_ximei: val.curNavIndex_ximei,
          curNavIndex_yuyue: val.curNavIndex_yuyue,
          curNavIndex_ximeiyuyue: val.curNavIndex_ximeiyuyue,
          curNavIndex_housePeizhi: val.curNavIndex_housePeizhi,
          curNavIndex_file: val.curNavIndex_file,
          curNavIndex_fileStatistics: val.curNavIndex_fileStatistics,
          curNavIndex_chanpin: val.curNavIndex_chanpin,
          curNavIndex_medical: val.curNavIndex_medical,
          curNavIndex_group: val.curNavIndex_group,
          curNavIndex_lifeservice: val.curNavIndex_lifeservice,
          curNavIndex_medicalservice: val.curNavIndex_medicalservice,
          curNavIndex_consumables: val.curNavIndex_consumables,
          curNavIndex_fictitious: val.curNavIndex_fictitious,
          curNavIndex_livingbody: val.curNavIndex_livingbody,
          curNavIndex_shuju: val.curNavIndex_shuju,
          curNavIndex_moneypk: val.curNavIndex_moneypk,
          curNavIndex_Newmoneypk: val.curNavIndex_Newmoneypk,
          curNavIndex_staffshuju: val.curNavIndex_staffshuju,
          curNavIndex_huotishuju: val.curNavIndex_huotishuju,
          curNavIndex_goodshuju: val.curNavIndex_goodshuju,
          curNavIndex_huotiZongcang: val.curNavIndex_huotiZongcang,
          curNavIndex_huotiStock: val.curNavIndex_huotiStock,
          curNavIndex_huotiMendian: val.curNavIndex_huotiMendian,
          curNavIndex_huotiCharge: val.curNavIndex_huotiCharge,
          curNavIndex_huotiPeizhi: val.curNavIndex_huotiPeizhi,
          curNavIndex_huoti: val.curNavIndex_huoti,
          curNavIndex_huodong: val.curNavIndex_huodong,
          curNavIndex_brand: val.curNavIndex_brand,
          curNavIndex_gongyingshang: val.curNavIndex_gongyingshang,
          curNavIndex_signature: val.curNavIndex_signature,
          curNavIndex_template: val.curNavIndex_template,
          // 旧仓储
          curNavIndex_caigouMendian: val.curNavIndex_caigouMendian,
          curNavIndex_caigou: val.curNavIndex_caigou,
          curNavIndex_wuliao: val.curNavIndex_wuliao,
          curNavIndex_kucun: val.curNavIndex_kucun,
          curNavIndex_chuku: val.curNavIndex_chuku,
          curNavIndex_ruku: val.curNavIndex_ruku,
          curNavIndex_yujing: val.curNavIndex_yujing,

          // 新仓储
          curNavIndex_caigouMendianNew: val.curNavIndex_caigouMendianNew,
          curNavIndex_caigouNew: val.curNavIndex_caigouNew,
          curNavIndex_kucunNew: val.curNavIndex_kucunNew,
          curNavIndex_chukuNew: val.curNavIndex_chukuNew,
          curNavIndex_rukuNew: val.curNavIndex_rukuNew,
          curNavIndex_yujingNew: val.curNavIndex_yujingNew,

          curNavIndex_tiaoma: val.curNavIndex_tiaoma,
          curNavIndex_dingding: val.curNavIndex_dingding,
          curNavIndex_msg: val.curNavIndex_msg,
          curNavIndex_quanxian: val.curNavIndex_quanxian,
          curNavIndex_yingxiao: val.curNavIndex_yingxiao,
          curNavIndex_version: val.curNavIndex_version,
          curNavIndex_vipPower: val.curNavIndex_vipPower,
          curNavIndex_mall: val.curNavIndex_mall,
          curNavIndex_xiaoxi: val.curNavIndex_xiaoxi,
          curNavIndex_refund: val.curNavIndex_refund,
          curNavIndex_controlStaff: val.curNavIndex_controlStaff,
          curNavIndex_controlRole: val.curNavIndex_controlRole,
          curNavIndex_controlRight: val.curNavIndex_controlRight,
          curNavIndex_shezhi: val.curNavIndex_shezhi,
          curNavIndex_program: val.curNavIndex_program,
          curNavIndex_petshop: val.curNavIndex_petshop,
          curNavIndex_petlooking: val.curNavIndex_petlooking,
          curNavIndex_petgift: val.curNavIndex_petgift,
          curNavIndex_breedplan: val.curNavIndex_breedplan,
          curNavIndex_join: val.curNavIndex_join,
          curNavIndex_special: val.curNavIndex_special,
          curNavIndex_goodsShop: val.curNavIndex_goodsShop,
          curNavIndex_goods: val.curNavIndex_goods,
          curNavIndex_oa: val.curNavIndex_oa,

          ip: val.ip,
          msg_unread_num_obj: val.msg_unread_num_obj,
          mendian: {
            isSanke: val.mendian.isSanke,
            cardCount: val.mendian.cardCount,
            userController: val.mendian.userController,
            userInfo: val.mendian.userInfo,
            curPetId: val.mendian.curPetId,
            saleList: val.mendian.saleList,
            saleTotal: val.mendian.saleTotal,
            remark: val.mendian.remark,
            remarkGuahao: val.mendian.remarkGuahao,
            jiedanItem: val.mendian.jiedanItem,
            curBusiness: val.mendian.curBusiness,
            curDiscountCard: val.mendian.curDiscountCard,
            isCollapse: val.mendian.isCollapse,
            dingjinOrder: val.mendian.dingjinOrder,
            curNavPanelPet: val.mendian.curNavPanelPet,
          },
          saleGiftCard: {
            saleList: val.saleGiftCard.saleList,
            remark: val.saleGiftCard.remark,
            total: val.saleGiftCard.total,
          },
          yiliaoxin: {
            userController: val.yiliaoxin.userController,
            userInfo: val.yiliaoxin.userInfo,
            danganNumber: val.yiliaoxin.danganNumber,
            curPetId: val.yiliaoxin.curPetId,
            curBusiness: val.yiliaoxin.curBusiness,
            platformParams: val.yiliaoxin.platformParams,
            guahaoParams: val.yiliaoxin.guahaoParams,
            jiezhenParams: val.yiliaoxin.jiezhenParams,
            ymqcParams: val.yiliaoxin.ymqcParams,
            ylfwParams: val.yiliaoxin.ylfwParams,
            bingliParams: val.yiliaoxin.bingliParams,
            zhuyuanParams: val.yiliaoxin.zhuyuanParams,
            yaofangParams: val.yiliaoxin.yaofangParams,
          },
          jiyang: {
            type: val.jiyang.type,
          },
          caiwu: {
            type: val.caiwu.type,
          },
          ximei: {
            type: val.ximei.type,
          },
          xizaoka: {
            type: val.xizaoka.type,
            curRow: val.xizaoka.curRow,
          },
          guahao: {
            type: val.guahao.type,
          },
          huiyuanquanyi: {
            type: val.huiyuanquanyi.type,
            curCard: val.huiyuanquanyi.curCard,
          },
          ymqc: {
            type: val.ymqc.type,
          },
          living: {
            type: val.living.type,
          },
          livingUpdate: {
            dingjinOrder: val.livingUpdate.dingjinOrder,
          },
          recharge: {
            type: val.recharge.type,
          },
          yajin: {
            type: val.yajin.type,
          },
          giftCard: {
            type: val.giftCard.type,
          },
          ing: {
            imgType: val.ing.imgType,
            text: val.ing.text,
          },
        };
      },
    }),
  ],
});
